import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config
      const ruta = config.url.split('/')

      // Para lanzar o refresh_token verificamos que a API devolve un 401 de non autenticado
      // e que a ruta que o devolve non é a de 'login' senon entraría nun bucle infinito
      if (response && response.status === 401 && ruta[3] !== 'login') {
        
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token.data.accessToken)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {          
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login (email, pwd) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}/login`, {
      username: email,
      password: pwd
    })
  },
  refreshToken () {        
    return new Promise((resolve, reject) => {
      axios.post('/refresh-token', {refresh_token: sessionStorage.getItem('refreshToken')})
        .then((response) => {
          sessionStorage.setItem('accessToken', response.data.accessToken)
          sessionStorage.setItem('refreshToken', response.data.refresh_token)
          store.dispatch('auth/setRefreshAccesToken', response.data.accessToken)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })     
  }
}
